<template>
  <div class="details-attachments">
    <div
      v-if="bdoFile && bdoFile.id"
      class="details-attachments__row"
    >
      <div class="d-flex">
        <div class="details-attachments__icon">
          <Icon name="attachment" />
        </div>
        <div class="details-attachments__content">
          <div class="details-attachments__name">
            {{ bdoFile.filename }}
          </div>
          <div class="details-attachments__meta">
            {{ formatValue(bdoFile.size, 'fileSize') }}
          </div>
        </div>
      </div>
      <div class="d-flex">
        <v-btn
          v-if="bdoCardId"
          class="mx-1"
          icon
          small
          :to="{name: 'singleBdo', params:{id: bdoCardId}}"
          title="Przejdź do karty"
        >
          <v-icon color="#252D3C">
            mdi-arrow-right-bold-box-outline
          </v-icon>
        </v-btn>
        <v-btn
          class="mx-1"
          icon
          small
          @click="unassignCard"
        >
          <v-icon color="#252D3C">
            mdi-pin-off-outline
          </v-icon>
        </v-btn>
        <v-btn
          class="mx-1"
          icon
          small
          @click="downloadFile(bdoFile.url, bdoFile.filename, '_blank')"
        >
          <Icon name="pobierz" />
        </v-btn>
      </div>
    </div>
    <div
      v-else
      class="py-3 px-6 details-attachments__name"
    >
      Brak przypiętej karty
    </div>
  </div>
</template>

<script>
import { downloadFile } from '../../../utils'
import { formatValue } from '../../../utils/typesEnum'
import { mapActions } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    currentTab: {
      type: Number,
      default: null
    },
    tableName: {
      type: String,
      default: ''
    }
  },
  computed: {
    bdoCardId() {
      const { bdoCardId, bdoCard, id } = this.data || {}
      if (id === this.currentTab || (this.currentTab === -1 && this.tableName === 'courses')) {
        return bdoCardId || bdoCard?.id
      }

      const { bdoCard: swapBdoCard, id: swapCourseId } = this.data.swapCourse || {}
      if (swapCourseId === this.currentTab || (this.currentTab === -1 && this.tableName === 'orders')) {
        return swapBdoCard?.id
      }

      return null
    },
    bdoFile() {
      const { bdoFile, bdoCard, id } = this.data
      if (id === this.currentTab || (this.currentTab === -1 && this.tableName === 'courses')) {
        return bdoFile || bdoCard?.bdoFile
      }

      const { bdoCard: swapBdoCard, id: swapCourseId } = this.data.swapCourse || {}
      if (swapCourseId === this.currentTab || (this.currentTab === -1 && this.tableName === 'orders')) {
        return swapBdoCard?.bdoFile
      }

      return null
    }
  },
  methods: {
    ...mapActions({
      unassignKpoCard: 'course/unassignKpoCard',
      setDialog: 'layout/setDialog',
    }),
    unassignCard() {
      if (this.bdoCardId) {
        this.unassignKpoCard({ item: this.data })
      } else {
        this.setDialog({
          data: { component: 'ConfirmDeleteDialog', text: 'Usuń plik oświadczenia', tableName: 'orders', deleteFileType: 'kpo', orderId: this.data.id },
          item: this.bdoFile
        })
      }
    },
    downloadFile (url, filename, target) {
      return downloadFile(url, filename, target)
    },
    formatValue,
  }
}
</script>
